const getters = {
  caseInfo: state => state.caseDetail.caseInfo,
  permList: state => state.permission.permList
}

export default getters
